import React from "react";
import { EmptyState, Flex, Link } from "@jsq/ds/core";
import { DistributionWorkflowStepProps } from "../../types";
import { completeStepContainer, emptyState } from "./styles_vanilla.css";

const CompleteStep: React.FC<DistributionWorkflowStepProps> = () => {
  return (
    <Flex className={completeStepContainer} alignItems="center" flexGrow={1}>
      <EmptyState
        illustration="document-success"
        title="Payments batch created"
        className={emptyState}
      >
        <Link displayAsButton href="/canopy/treasury/transactions" variant="primary">
          Go to transactions dashboard
        </Link>
      </EmptyState>
    </Flex>
  );
};

export default CompleteStep;
